import { useTranslation } from "react-i18next";
import { Icon, Popup } from "semantic-ui-react";

import "modules/CommunicationTemplates/components/InfoPopup/InfoPopup.scss";

export const InfoPopup = () => {
  const { t } = useTranslation();

  return (
    <Popup
      size="large"
      flowing
      hoverable
      content={
        <div className="CommunicationTemplateInfoPopup__content">
          {t("v8_template_editor_info_popup_content") ||
            "There are five css classes available to style the background and title of the content generated by this variable called CustomBackground, CustomTitle, CustomContent, CustomTotal and CustomVAT. They can be used to set background color or font size/color. Example:"}
          <pre>
            {`<style> 
.CustomBackground {
  background-color: #eee;
}
.CustomTitle {
  font-size: 24px;
  color: red;
}
.CustomContent {
  font-size: 24px;
  color: red;
}
</style>`}
          </pre>
        </div>
      }
      trigger={<Icon name="question" />}
    />
  );
};
